module.exports = __webpack_public_path__ + "static/media/logo-8coin.e4d946bf.png";